import fourStateInternationalTrucksDefaults from '../uvr8lhx57w-1/config.js';

export default {
  ...fourStateInternationalTrucksDefaults,
  includes: ['bigcommerce-generic', 'uvr8lhx57w-1'],
};
